import { Box, MuiModal } from '@pinchenterprisesnpm/friday-ui'
import { InfoBanner } from '@src/features/shift-post-v2/components/info-banner'
import { SectionItemText } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/screening-section.styles'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { ShiftBadges } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/components'

const { Header, Content } = MuiModal

interface IEditScreeningModalProps {
  isOpen: boolean
  closeModal: () => void
}

export const EditScreeningModal = ({
  isOpen,
  closeModal,
}: IEditScreeningModalProps) => {
  const infoBannerMessages =
    'Contact your Account Manager to get additional screening requirements enabled for your account.'
  return (
    <MuiModal
      isOpen={isOpen}
      closeModal={closeModal}
      sx={{
        '& .MuiDialogContent-root': {
          height: '600px',
          position: 'relative',
        },
      }}
    >
      <Header title="Edit Screening Requirements" />
      <Content>
        <Box px="sm">
          <SectionItemText>
            Only allow Upshifters with the selected screening requirements to
            book this shift.
          </SectionItemText>
        </Box>

        <InfoBanner description={infoBannerMessages} icon={faInfoCircle} />

        <ShiftBadges />
      </Content>
    </MuiModal>
  )
}
